<mat-expansion-panel
  [ngClass]="border()"
  class="eiq-expansion-panel"
  [expanded]="expanded()"
  hideToggle
  (opened)="expanded$.set(true); expand.emit(true)"
  (closed)="expanded$.set(false); expand.emit(false)"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <ng-content select="[slot=title]"></ng-content>
    </mat-panel-title>

    <div class="eiq-expansion-panel__collapse-action">
      <span class="text__sm" [ngClass]="'eiq-text-' + color()">{{ expanded$() ? 'Collapse' : 'Expand' }}</span>
      <fa-icon [ngClass]="'eiq-icon-' + color()" [@iconRotate]="expanded$() ? 'expanded' : 'collapsed'" [icon]="faChevronDown"></fa-icon>
    </div>
  </mat-expansion-panel-header>

  <div class="content">
    <ng-content select="[slot=content]"></ng-content>
  </div>
</mat-expansion-panel>
